// extracted by mini-css-extract-plugin
export default {"reuseLayout":"reuse_reuseLayout__OTf0U","arrowBack":"reuse_arrowBack__nH5UB","reuse":"reuse_reuse__O+Kb+"};